<template>
  <v-container fluid class="user-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
          centered
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            User
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-password`"
          >
            <v-icon class="mr-3">mdi-lock</v-icon>
            Change Password
          </v-tab>
          <v-tab></v-tab>

          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit User</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'username')"
                        v-bind:value="initvalue.username"
                        placeholder="User Name"
                        persistent-hint
                        single-line hint="Enter the user name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'userid')"
                        v-bind:value="initvalue.userid"
                        placeholder="User Id"
                        persistent-hint
                        single-line hint="Enter the user id">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'useremail')"
                        v-bind:value="initvalue.useremail"
                        placeholder="User Email"
                        persistent-hint
                        single-line hint="Enter user password. Min 6 characters long">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.usertype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'usertype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the user type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'userstatus')"
                          v-bind:label="initvalue.userstatus"
                          v-model="initvalue.userstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editUser()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-password'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Password</p>
                      <v-text-field
                          class="mb-4"
                          outlined
                          dense
                          value=""
                          v-model="password.userpassword"
                          v-bind:error="password.error"
                          placeholder="New Password"
                          persistent-hint
                          single-line hint="Enter user password. Min 6 characters long">
                      </v-text-field>
                      <v-text-field
                          class="mb-4"
                          outlined
                          dense
                          value=""
                          v-model="password.userpassword2"
                          v-bind:error="password.error2"
                          placeholder="Verify Password"
                          persistent-hint
                          single-line hint="Confirm user password. Min 6 characters long">
                      </v-text-field>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPassword()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      user: {},
      photo: {},
      password: {
        error: false,
        error2: false
      },
      initvalue: {},
      imageurl: undefined,
      items: ['System Administrator', 'Company Administrator', 'Sales Representative'],
      lang: ['English', 'Russian', 'Latin'],
      checkbox: {
        email: true,
        messages: true,
        phone: true,
      },
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('User', [
      'updateUserRequest',
      'updateUserImageRequest',
      'updateUserPasswordRequest',
      'getUsersRequest'
    ]),
    editUser() {
      this.user._id = this.initvalue._id;
      this.updateUserRequest(this.user);
      this.getUsersRequest();
      router.push('/user/list');
    },
    editPhoto() {
      console.log(this.photo)
      this.photo._id = this.initvalue._id;
      this.updateUserImageRequest(this.photo);
      this.getUsersRequest();
      router.push('/user/list');
    },
    editPassword() {
      console.log(this.password);
      if(this.password.userpassword == undefined || this.password.userpassword.length<6){
        this.password.error = true;
        return;
      }
      this.password.error = false;
      if(this.password.userpassword !== this.password.userpassword2){
        this.password.error2 = true;
        return;
      }
      this.password.error2 = false;
      this.password._id = this.initvalue._id;
      console.log(this.password);
      this.updateUserPasswordRequest(this.password);
      this.getUsersRequest();
      router.push('/user/list');
    },
    updateChangedValue(value, field){
      console.log(value, field);
      this.user[field] = value;
    },
      createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.userimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('User', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.userimage;
    console.log(this.initvalue);
    if(!this.initvalue._id) this.$router.push({ name: 'UserList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
